var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleAdsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.616,
    height: 25.232,
    viewBox: "0 0 27.616 25.232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3632",
    "data-name": "Group 3632",
    transform: "translate(10 -0.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2984",
    "data-name": "Path 2984",
    d: "M110.656,3.678a4.99,4.99,0,0,1,1.179-1.868A4.618,4.618,0,0,1,119.1,2.889c1.112,2.024,2.291,4,3.437,6.006,1.913,3.325,3.848,6.651,5.739,9.987a4.6,4.6,0,1,1-8.041,4.46q-2.519-4.387-5.049-8.764a1,1,0,0,0-.122-.178,1.811,1.811,0,0,1-.367-.545c-.745-1.312-1.513-2.614-2.258-3.915-.478-.845-.979-1.679-1.457-2.525a4.605,4.605,0,0,1-.612-2.447,3.41,3.41,0,0,1,.289-1.29",
    transform: "translate(-111.258 0)",
    fill: "#2377be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2985",
    "data-name": "Path 2985",
    d: "M12.982,42.493a6.391,6.391,0,0,0-.211,1.223,4.8,4.8,0,0,0,.667,2.614q1.835,3.153,3.659,6.328c.111.189.2.378.311.556-.667,1.157-1.335,2.3-2.013,3.459-.934,1.613-1.868,3.236-2.814,4.849-.044,0-.056-.022-.067-.056a.689.689,0,0,1,.044-.256A4.476,4.476,0,0,0,11.491,56.8,4.239,4.239,0,0,0,8.878,55.45a4.514,4.514,0,0,0-3.57.99c-.189.145-.311.356-.534.467a.074.074,0,0,1-.078-.056c.534-.923,1.057-1.846,1.59-2.769q3.3-5.739,6.617-11.466c.022-.045.056-.078.078-.122",
    transform: "translate(-13.584 -38.815)",
    fill: "#fcab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2986",
    "data-name": "Path 2986",
    d: "M-8.844,213.807c.211-.189.412-.389.634-.567a4.6,4.6,0,0,1,7.351,2.792,4.889,4.889,0,0,1-.178,2.369,1.163,1.163,0,0,1-.044.189c-.1.178-.189.367-.3.545a4.471,4.471,0,0,1-4.36,2.324,4.565,4.565,0,0,1-4.215-3.982,4.451,4.451,0,0,1,.612-2.958c.111-.2.245-.378.367-.578.056-.044.033-.133.133-.133",
    transform: "translate(0 -195.737)",
    fill: "#3d993c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAdsIcon);
export default __webpack_public_path__ + "static/media/googleAdsIcon.d6379fdb6cc85c993150124218972ca2.svg";
export { ForwardRef as ReactComponent };